/**
 * Created by Daniela on 19/12/2016.
 */
import { Injectable } from '@angular/core';

import { CategoriaCnh } from "./categoria-cnh.model";
import { apiName } from "./data.service";
import { RestService } from "../../../../core/services/rest.service";

@Injectable()
export class CategoriaCnhApiService {

    constructor(
        private _restService: RestService
    ) { }

    onPost(object: CategoriaCnh, done: any) {
        this._restService.onPost(apiName, object, done);
    }

    onPut(object: CategoriaCnh, done: any) {
        this._restService.onPut(apiName, object, done);
    }

    onDelete(objectId: number, done: any) {
        this._restService.onDelete(apiName, objectId, done);
    }

    onGetAll(done: any) {
        var filter: any = {"order":"categoria","where":{"ativo":true}};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetAllVeiculo(done: any) {
        var filter: any = {"order":"categoria","where":{"ativo":true,"veiculo": true}};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetById(objectId: number, done: any) {
        this._restService.onGetPostId(apiName, objectId, {}, done);
    }

    onGetApiUrl() {
        return apiName;
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/cnh/categorias-cnh/shared/categoria-cnh-api.service.ts
 **/